import { PetInsuranceData, PaymentFrequency } from "./petInsurance";

export interface PremiumPetEntry {
  petName: string;
  petGender: string;
  species: string;
  breed: string;
  breedType: string;
  housecat: boolean | null;
  tallDog: boolean | null;
  petBirthdate: string;
  neutered: boolean;
  coverageLevel: string;
  preexistingConditions: boolean;
  globalCoverage: boolean;
  liability: boolean;
  medicalFoodCoverage?: boolean;
  preventionCoverage?: boolean;
  excess: number;
  copayment: number;
}

export class CalculatePremiumRequest {
  petList: PremiumPetEntry[];
  paymentFrequency: 'm' | 'q' | 'b' | 'y';

  constructor(data: { petList: PremiumPetEntry[], paymentFrequency: PaymentFrequency }) {
    this.petList = data.petList;

    switch (data.paymentFrequency) {
      case PaymentFrequency.BIYEARLY:
        this.paymentFrequency = 'b';
        break;
      case PaymentFrequency.QUARTERLY:
        this.paymentFrequency = 'q';
        break;
      case PaymentFrequency.MONTHLY:
        this.paymentFrequency = 'm';
        break;
      case PaymentFrequency.YEARLY:
        this.paymentFrequency = 'y';
        break;
      default:
        this.paymentFrequency = 'm';
        break;
    }
  }

  static petEntryFromInsuranceData(pet: PetInsuranceData): PremiumPetEntry {
    return {
      petName: pet.pet_name,
      breed: pet.breed,
      breedType: pet.breed_type ? 'cross' : (pet.breed.includes('mischling') ? 'mixed' : 'pedigree'),
      petGender: pet.pet_gender[0],
      species: pet.pet_species,
      petBirthdate: new Date(pet.birthdate).toISOString().split('T')[0],
      copayment: pet.deductible_percentage_until_9_years,
      excess: pet.annual_franchise,
      coverageLevel: pet.product_bundle.toLowerCase(),
      neutered: pet.neutered,
      globalCoverage: true,
      preexistingConditions: pet.preexisting_conditions_coverage.preexisting_conditions,
      medicalFoodCoverage: pet.medical_food_coverage.coverage_selected,
      preventionCoverage: pet.preventive_care_coverage.coverage_selected,
      housecat: pet.housecat ?? null,
      tallDog: pet.pet_species === 'dog' && pet.breed.includes('mischling_gross'),
      liability: false,
    };
  }
}
